export default __webpack_public_path__ + "static/media/fil.96764eb6.png";